import React, { useState } from 'react';
import './styles.css';
import SocialLinks from './SocialLinks';

function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLinkClick = () => {
    setIsOpen(false); // Close the sidebar
  };

  return (
    <>
   
      
      <button
        className={`toggle-sidebar ${isOpen ? 'rotate' : ''}`}
        onClick={toggleSidebar}
      >
        {isOpen ? '✖' : '☰'}
      </button>

      <SocialLinks />

      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <nav>
          <ul>
            <li><a href="#Projects" onClick={handleLinkClick}>Projects</a></li>
            <li><a href="#AboutMe" onClick={handleLinkClick}>About</a></li>
            <li><a href="#Footer" onClick={handleLinkClick}>Contacts</a></li>
          </ul>
        </nav>
      </div>
    </>
  );
}

export default Sidebar;
